import { render, staticRenderFns } from "./QMessageBox.vue?vue&type=template&id=78134859&"
import script from "./QMessageBox.vue?vue&type=script&lang=js&"
export * from "./QMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports